import { render } from "./RegistrationPark.vue?vue&type=template&id=a6c402ca"
import script from "./RegistrationPark.vue?vue&type=script&lang=js"
export * from "./RegistrationPark.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__